import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount, ref } from 'vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import TextRenderer from '@/components/editor/TextRenderer.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useIcons from '@/composables/useIcons'
  import useCourse from '@/composables/useCourse'
  import { EditorModule } from '@/store/modules/editor'
  import { v4 as uuidv4 } from 'uuid'
  import type { EditorStatePayload, LessonMap } from '@/services/interfaces/Course'
  import eventBus from '@/main'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LeuckentextEditor',
  setup(__props) {

  const { trashIcon } = useIcons()
  const { lessonId } = useCourse()
  const transitionName = ref('')

  const originalLeuckentext = computed(() => {
    if (EditorModule.leuckentextDeleteParams?.id) return null
    return EditorModule.currentLesson?.leuckentext?.id ? EditorModule.currentLesson?.leuckentext : null
  })

  const leuckentext = computed(() => EditorModule.lessonLeuckentext)
  const leuckentextItems = computed(() => {
    return leuckentext.value?.leuckentextItems?.filter((item) => item._destroy !== true) || []
  })

  const leuckentextRedoCallback = (data: EditorStatePayload) => {
    const statement = leuckentext.value?.leuckentextItems.find(
      (item) => (data.value as LessonMap).questionId === (item.id || item.editorId),
    )
    if (statement) (statement as any)[data.property!] = data.apiPayload as string
    else leuckentext.value![data.property as 'title' | 'description'] = data.apiPayload as string
  }

  const leuckentextUndoCallback = (data: EditorStatePayload) => {
    const statement = leuckentext.value?.leuckentextItems.find(
      (item) => (data.value as LessonMap).questionId === (item.id || item.editorId),
    )
    if (statement) (statement as any)[data.property!] = (data.value as LessonMap).prevPropValue
    else {
      leuckentext.value![data.property as 'title' | 'description'] = (data.value as LessonMap).prevPropValue as string
    }
  }

  const mutateAndQueueFunc = (statementId?: string) => {
    return async (data: EditorStatePayload) => {
      const changesPayload = EditorModule.editorChanges[data.path]?.find((c) => c.data.key === data.key)
      let statement: any
      if (statementId) {
        statement = leuckentext.value?.leuckentextItems.find((item) => statementId === (item.id || item.editorId))
      }

      const newData = Object.assign({}, data, {
        apiPayload: data.value,
        value: {
          questionId: statementId || '',
          prevPropValue:
            (changesPayload?.data.value as LessonMap)?.prevPropValue ??
            (statement?.[data.property!] || leuckentext.value![data.property as 'title' | 'description'] || ''),
        },
      })
      await EditorModule.addEditorChange(newData)
      if (statement) statement![newData.property!] = newData.apiPayload as string
      else leuckentext.value![data.property as 'title' | 'description'] = newData.apiPayload as string

      EditorModule.subscribe({
        type: 'save',
        key: data.key,
        callback: leuckentextRedoCallback,
        allowDuplicate: true,
      })
      EditorModule.subscribe({
        type: 'discard',
        key: 'discard-' + data.key,
        callback: leuckentextUndoCallback,
      })
    }
  }

  const addNewStatement = () => {
    transitionName.value = 'fadeInUp'
    const editorId = 'editor-question-' + uuidv4()
    leuckentext.value?.leuckentextItems.push({
      editorId,
      text: '',
      orderNumber: leuckentext.value.leuckentextItems.length + 1,
    })
  }

  const removeStatement = (id: string | undefined) => {
    if (!id) return

    transitionName.value = 'next-slide'
    const itemIndex = leuckentext.value!.leuckentextItems.findIndex((item) => id === (item?.editorId || item.id))
    if (leuckentext.value?.leuckentextItems[itemIndex]?.editorId) {
      leuckentext.value?.leuckentextItems.splice(itemIndex, 1)
    } else eventBus.$set(leuckentext.value!.leuckentextItems[itemIndex], '_destroy', true)
  }

  const removeLeuckentext = async () => {
    if (leuckentext.value!.id) {
      EditorModule.setLeuckentextDeleteParams({
        id: leuckentext.value!.id,
        lessonId: lessonId.value,
      })
    }
    EditorModule.setLeuckentext(null)
  }
  const showEditorContainer = () => {
    EditorModule.setLeuckentext({
      editorId: uuidv4(),
      lessonId: lessonId.value,
      title: '',
      description: '',
      leuckentextItems: [],
      successMessage: '',
      failureMessage: '',
    })
  }

  onBeforeUnmount(() => {
    EditorModule.unsubscribe({ type: 'discard', callback: leuckentextUndoCallback })
    EditorModule.unsubscribe({ type: 'save', callback: leuckentextRedoCallback })
  })

return { __sfc: true,trashIcon, lessonId, transitionName, originalLeuckentext, leuckentext, leuckentextItems, leuckentextRedoCallback, leuckentextUndoCallback, mutateAndQueueFunc, addNewStatement, removeStatement, removeLeuckentext, showEditorContainer, computed, onBeforeUnmount, ref, KetchUpButton, TextRenderer, SVGRenderer, useIcons, useCourse, EditorModule, uuidv4, eventBus }
}

})